import { Component, OnInit } from '@angular/core';
import { TranslationPipe } from '../../../pipes/translation.pipe';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { FluidModule } from 'primeng/fluid';
import { CardModule } from 'primeng/card';
import { CalendarWidgetComponent } from '../../widgets/calendar-widget/calendar-widget.component';
import { DateTime } from 'luxon';
import { SkeletonModule } from 'primeng/skeleton';
import { AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { CustomerClient, CustomerNameDto, TreatmentClient, TreatmentShortInfoDto } from '../../../api/api-client';
import { FeedbackDataService } from '../../../services/feedback-data.service';
import { RippleModule } from 'primeng/ripple';
import { DashboardTreatmentsListComponent } from './dashboard-treatments-list/dashboard-treatments-list.component';
import { SubscriptionManager } from '../../../services/subscription-manager.service';

@Component({
  selector: 'app-dashboard',
  imports: [RouterModule,
    TranslationPipe,
    SkeletonModule,
    AutoCompleteModule,
    FluidModule,
    ButtonModule,
    MenuModule,
    ToastModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    CardModule,
    CalendarWidgetComponent,
    CalendarWidgetComponent,
    RippleModule,
    DashboardTreatmentsListComponent
  ],
  providers: [TranslationPipe, SubscriptionManager],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  items: MenuItem[] | undefined;
  treatmentsOfTheMonth!: TreatmentShortInfoDto[];
  nextTreatments!: TreatmentShortInfoDto[];
  lastTreatments!: TreatmentShortInfoDto[];
  areTreatmentsLoaded: boolean = false;
  allCustomerNames!: CustomerNameDto[];
  customerNamesSuggestions!: CustomerNameDto[];

  constructor(
    private readonly subscriptionManager: SubscriptionManager,
    private readonly route: ActivatedRoute,
    private readonly translationPipe: TranslationPipe,
    private readonly treatmentService: TreatmentClient,
    private readonly customerService: CustomerClient,
    private readonly router: Router,
    private readonly feedbackService: FeedbackDataService
  ) {
    this.items = [
      {
        label: this.translationPipe.transform('Customer'),
        iconClass: 'material-icons !text-[1rem]',
        icon: 'person',
        routerLink: '../customers/create'
      },
      {
        label: this.translationPipe.transform('Patient'),
        iconClass: 'material-icons !text-[1rem]',
        icon: 'pets',
        routerLink: '../pets/create',
        queryParams: { 'calledFromDashboard': 'true' }
      },
      {
        label: this.translationPipe.transform('Treatment'),
        iconClass: 'material-icons !text-[1rem]',
        icon: 'event',
        routerLink: '../treatments/create',
        queryParams: { 'calledFromDashboard': 'true' }
      }
    ];
    this.feedbackService.feedbackData = null;
  }

  ngOnInit(): void {
    this.subscriptionManager.call(
      this.treatmentService.getAllTreatmentsForTenantInMonth(DateTime.now().month),
      (x => {
        this.treatmentsOfTheMonth = x.result;//.sort((a,b)=>DateTime.fromISO(a.appointmentDate??"").diffNow().as('minutes')-DateTime.fromISO(b.appointmentDate??"").diffNow().as('minutes'))
        this.nextTreatments = x.result
          .filter(x => x.appointmentDate.diffNow().as('minutes') > 0)
          .sort((a, b) => (a.appointmentDate.toMillis() - b.appointmentDate.toMillis()))
          .slice(0, 3);
        this.lastTreatments = x.result
          .filter(x => x.appointmentDate.diffNow().as('minutes') < 0)
          .sort((a, b) => (b.appointmentDate.toMillis() - a.appointmentDate.toMillis()))
          .slice(0, 3);
        this.areTreatmentsLoaded = true;
      })
    );
    this.subscriptionManager.call(
      this.customerService.getAllCustomerNames(),
      (x => this.allCustomerNames = x.result)
    );
  }

  hasMaterialIconClass(item: MenuItem) {
    let classList = item.iconClass ?? ''.split(' ');
    return classList.includes('material-icons');
  }

  getDate(date: DateTime) {
    return date.toLocaleString({ day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  getTime(date: DateTime) {
    return date.toLocaleString(DateTime.TIME_24_SIMPLE);
  }

  queryCustomerNames($event: AutoCompleteCompleteEvent) {
    this.customerNamesSuggestions = this.allCustomerNames.filter(x => (x.firstName + x.lastName).toLocaleLowerCase().includes($event.query.toLocaleLowerCase()));
  }

  getCustomerNameFromDto(dto: CustomerNameDto) {
    return dto.firstName + ' ' + dto.lastName;
  }

  openCustomer($event: AutoCompleteSelectEvent) {
    this.router.navigate(['loggedin/customer-detail/' + $event.value.id]);
  }
}
